import {Component, OnInit, Directive, Output, Input, EventEmitter} from '@angular/core';
import {CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { CITIES } from '../../constants/cities';
import {City} from '../city';

@Component({
    selector: 'cities-seeker',
    providers: [CompleterService],
    template: require('./cities-seeker.component.html'),
})
export class CitiesSeekerComponent implements OnInit{    

    private dataService: CompleterData;
    citySearcher: string;
    selectedCities: City[];
    overCity: City;
    @Input('loadedCitiesIds') citiesIds: Number[];
    @Output() emiter = new EventEmitter();      

    constructor(private _completerService: CompleterService) {
         this.dataService = this._completerService.local(CITIES, 'name', 'name');
         this.citySearcher = "";
         this.selectedCities = [];     
         this.overCity = null;    
    }
    
    ngOnInit() {
        for(var i = 0; i < CITIES.length; i++) {
            for(var j = 0; j < this.citiesIds.length; j++) {
                if(CITIES[i].id == this.citiesIds[j]) {
                    var city: City = {"id": CITIES[i].id, "name": CITIES[i].name};
                    if(!this.selectedCitiesContainsCity(this.selectedCities, city)) {
                        this.selectedCities.push(city);
                    }
                }
            }
        }
        // if(this.selectedCities.length > 0) {
        //     this.emiter.emit({
        //         value: this.selectedCities
        //     })
        // }
    }    

    public onCitySelected() {  
        
        for(var i = 0; i < CITIES.length; i++) {
            if(CITIES[i].name == this.citySearcher) {
                var cityId = CITIES[i].id;
            }
        }        
        var selectedCity: City = {"id": cityId, "name": this.citySearcher};        
        if(!this.selectedCitiesContainsCity(this.selectedCities, selectedCity)) {
            this.selectedCities.push(selectedCity);            
            this.emiter.emit({
                value: this.selectedCities
            })
        }
    }

    selectedCitiesContainsCity(cities: City[], city: City): boolean {
        var contains: boolean = false;
        for(var i = 0; i < cities.length; i++) {
            if(cities[i].name === city.name) {
                contains = true;
            }
        }
        return contains;
    }

    mouseOverCity(city: City) {
        this.overCity = city;
    }

    mouseLeaveCity() {
        this.overCity = null;
    }

    deleteCity(city: City) {
        var index = this.selectedCities.indexOf(city);                
        this.selectedCities.splice(index, 1);        
        this.emiter.emit({
            value: this.selectedCities
        })
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/cities_seeker/cities-seeker.component.ts
 **/